import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { API_URL, API_BASE_URL } from '../API/endpoint';
import './ProductDetail.css'; // Créez ce fichier CSS si besoin

const ProductDetail = () => {
  const { categoryId, productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(`${API_URL}/products/${productId}`);
        if (!response.ok) {
          throw new Error('Produit non trouvé');
        }
        const data = await response.json();
        setProduct(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  if (loading) {
    return <div className="sitemap-loading">Chargement du produit...</div>;
  }

  if (error) {
    return <div className="sitemap-error">Erreur : {error}</div>;
  }

  if (!product) {
    return <div className="sitemap-not-found">Produit non trouvé.</div>;
  }

  return (
    <div className="sitemap-product-detail">
      <Helmet>
        <title>{product.title} - Déco Ariège</title>
        <meta name="description" content={`${product.description?.substring(0, 150) || product.title} - Produit artisanal en bois fait main en Ariège. Prix: ${product.price}€`} />
        <meta property="og:title" content={`${product.title} - Déco Ariège`} />
        <meta property="og:description" content={product.description || product.title} />
        <meta property="og:image" content={`${API_BASE_URL}${product.path}`} />
        <meta property="og:type" content="product" />
        <link rel="canonical" href={`https://deco-bois.3d-pixel.fr/boutique/${product.category?.id}/${product.id}`} />
      </Helmet>
      <h1>{product.title}</h1>
      <div className="sitemap-product-images">
        {product.path && (
          <img
            src={`${API_BASE_URL}${product.path}`}
            alt={product.title}
            className="sitemap-main-image"
          />
        )}
      </div>
      <div className="sitemap-product-info">
        <p className="sitemap-price">{product.price} €</p>
        <p className="sitemap-description">{product.description}</p>
        <p className="sitemap-category">Catégorie : {product.category?.name}</p>
        <button className="sitemap-add-to-cart">Ajouter au panier</button>
      </div>
    </div>
  );
};

export default ProductDetail;